import React from "react";

function PaymentIcon({ stroke = "white" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 5.9375C1.25 5.19158 1.54632 4.47621 2.07376 3.94876C2.60121 3.42132 3.31658 3.125 4.0625 3.125H15.9375C16.6834 3.125 17.3988 3.42132 17.9262 3.94876C18.4537 4.47621 18.75 5.19158 18.75 5.9375V14.0625C18.75 14.8084 18.4537 15.5238 17.9262 16.0512C17.3988 16.5787 16.6834 16.875 15.9375 16.875H4.0625C3.31658 16.875 2.60121 16.5787 2.07376 16.0512C1.54632 15.5238 1.25 14.8084 1.25 14.0625V5.9375ZM4.0625 4.375C3.6481 4.375 3.25067 4.53962 2.95765 4.83265C2.66462 5.12567 2.5 5.5231 2.5 5.9375V6.875H17.5V5.9375C17.5 5.5231 17.3354 5.12567 17.0424 4.83265C16.7493 4.53962 16.3519 4.375 15.9375 4.375H4.0625ZM2.5 14.0625C2.5 14.4769 2.66462 14.8743 2.95765 15.1674C3.25067 15.4604 3.6481 15.625 4.0625 15.625H15.9375C16.3519 15.625 16.7493 15.4604 17.0424 15.1674C17.3354 14.8743 17.5 14.4769 17.5 14.0625V8.125H2.5V14.0625ZM13.125 11.875H15C15.1658 11.875 15.3247 11.9408 15.4419 12.0581C15.5592 12.1753 15.625 12.3342 15.625 12.5C15.625 12.6658 15.5592 12.8247 15.4419 12.9419C15.3247 13.0592 15.1658 13.125 15 13.125H13.125C12.9592 13.125 12.8003 13.0592 12.6831 12.9419C12.5658 12.8247 12.5 12.6658 12.5 12.5C12.5 12.3342 12.5658 12.1753 12.6831 12.0581C12.8003 11.9408 12.9592 11.875 13.125 11.875Z"
        fill={stroke}
      />
    </svg>
  );
}

export default PaymentIcon;
